"use client";

import { Button } from "@/components/ui/button";
import useAuth from "@/features/authentication/hooks/useAuth";
import MenuProfile from "@/components/molecules/menuProfile/MenuProfile";
import ProfileIcon from "@/components/atoms/svg/icons/ProfileIcon";
import { PROFILE_MENU } from "@/constants/menu";
import { IProfile } from "@/interfaces/IProfile";

export default function ProfileDropdown(props: Pick<IProfile, "email">) {
  const { onLogout } = useAuth();
  return (
    <div
      id="profile-dropdown"
      className="w-[220px] h-auto bg-background rounded-2xl border border-solid border-base-divider shadow-profile-dropdown py-2 px-4"
    >
      <div className="flex flex-col gap-1 items-center justify-between">
        {/* TODO: Improve this style */}
        <div className="flex w-full h-6 px-2 gap-2 items-center">
          <ProfileIcon />
          <p className="text-base-tertiary text-xs">{props.email}</p>
        </div>
        <MenuProfile
          list={PROFILE_MENU}
          className="!p-0 w-full border-none"
          classNameUl="gap-[3px]"
          classNameActive="!py-0"
          classNameNoActive="!py-0"
        />
        <Button
          className="w-full btn-default flex-1 gap-1 font-medium leading-caption-l tracking-caption-l text-base-primary border-action-normal border h-8 max-h-8 mt-auto"
          onClick={onLogout}
        >
          Log out
        </Button>
      </div>
    </div>
  );
}
